/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: CZH
 * @LastEditTime: 2022-10-28 16:50:47
 * @Description:
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const bgglService = {

  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfjc/jcbg`, { params: params }); },

  // 作废
  invalid: (id) => { return axios.put(`${iffApi}/xfjc/jcbg/${id}/invalid`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfjc/jcbg/export`, { responseType: 'blob', params }); },

  // 获取详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfjc/jcbg/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfjc/jcxm`, fd); },

  // 更新
  update: (id, fd) => { return axios.put(`${iffApi}/xfjc/jcxm/${id}`, fd); },

  // 生成报告
  scbg: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/scbg`); },

  // 是否需要生成报告
  isNeedScbg: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/isNeedScbg`); },

  // 签章
  qz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/qz`); },

  // 是否需要签章
  isNeedQz: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/isNeedQz`); },

  // 盖章
  gz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/gz`); },

  // 是否需要盖章
  isNeedGz: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/isNeedGz`); },

  // 获取检测结论说明
  getJcjl: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/jcjl`); },

  // 保存检测结论说明
  saveJcjl: (id, fd) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/jcjl`, fd); },

  // 重新检测
  cxpg: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/cxjc`); },

  // 加盖公章
  jggz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/jggz`); }

};
